<template>
  <Catalogs
    title="Типы расходов исполнителя"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'WorkerCostTypeAdd'"
    :route-edit="'WorkerCostTypeEdit'"
    :route-view="'WorkerCostTypeView'"
    :route-path="'/worker_cost_types'"
    :can-edit="canEditWorkerCostTypeCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerCostTypes",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getWorkerCostTypes(data);
    },
    canEditWorkerCostTypeCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_COST_TYPE_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerCostTypes/WorkerCostTypes.vue